define(
({
  "alert": "Alerta",
  "okay": "Vale"
})
);
